import Button from "@/components/atom/Button";
import Input from "@/components/atom/Input";
import Loading from "@/components/atom/Loading";
import { addAddressDropsip, getGroupArea } from "@/functions/databaseData";
import handleErrorAPI from "@/functions/handleErrorAPI";
import useAlert from "@/functions/useAlert";
import useHeader from "@/functions/useHeader";
import { useRouter } from "next/navigation";
import phone from "phone";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";

export default function TambahCustomer() {
  const { showAlert } = useAlert();
  const router = useRouter();
  const { session } = useHeader();
  const [forms, setForms] = useState({});
  const [errors, setErrors] = useState({});

  const [showDropdown, setShowDropdown] = useState({
    key: false,
  });
  const [area, setArea] = useState({
    province: [],
    city: [],
    district: [],
    sub_district: [],
  });

  const handleChange = (name) => (value) => {
    if (
      name == "telephone" &&
      (value.startsWith("0") || value.startsWith("62"))
    ) {
      value = "+62" + value.slice(2);
    }
    setForms((form) => ({
      ...form,
      [name]: value,
    }));
  };

  const handleChangeError = (name) => (value) => {
    setErrors((error) => ({
      ...error,
      [name]: value,
    }));
  };

  async function handleSave() {
    const settingToast = {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };

    if (
      !phone(
        !forms?.telephone?.startsWith("+")
          ? `+${forms?.telephone}`
          : forms?.telephone
      )?.isValid
    ) {
      handleChangeError("telephone")("No Telephone tidak valid");
      return toast.error("No Telephone tidak valid", settingToast);
    }
    if (!forms?.alamat?.kelurahan?.id) {
      handleChangeError("telephone")("");
      handleChangeError("alamat")("Silahkan masukkan alamat");
      return toast.error("Alamat tidak lengkap", settingToast);
    }
    try {
      const res = await addAddressDropsip({
        body: {
          recipets_name: forms?.recipets_name, // name penerima
          telephone: forms?.telephone, // format menggunakan kode negara
          address: forms?.address,
          id_area: forms?.alamat?.kelurahan?.id, // id area yang di dapat dari list area
        },
        token: session?.user?.token,
        id: session?.user?.data?.mitra_id,
      });
      if (!res?.error) {
        setErrors({});
        router.back();
        return showAlert({
          colors: "success",
          title: "Berhasil Ditambahkan",
          desc: "Anda berhasil menambahkan.",
          handleClick: {
            open: {
              onClick: () => {},
              text: "Tutup",
              hide: false,
            },
            close: {
              onClick: () => {},
              text: "tetap di halaman ini!",
              hide: true,
            },
          },
        });
      } else {
        const stateError = ["recipets_name", "telephone", "area_id", "address"];
        handleErrorAPI(res?.error, setErrors, stateError);
        const key = checkErrorMsg(res.error.message, stateError);
        return toast.error(`Error : ${key}`, settingToast);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleDropdown(state) {
    setShowDropdown((old) => ({ ...old, [state]: !showDropdown?.[state] }));
  }

  useEffect(() => {
    run();
  }, [
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const run = useCallback(async () => {
    try {
      const payload = {
        province: forms?.alamat?.provinsi?.id,
        city: forms?.alamat?.kabupaten,
        district: forms?.alamat?.kecamatan,
      };
      !forms?.alamat?.provinsi?.id && delete payload?.province;
      !forms?.alamat?.kabupaten && delete payload?.city;
      !forms?.alamat?.kecamatan && delete payload?.district;

      const data_area = await getGroupArea(payload);
      const thisvalue =
        area?.province?.length <= 0
          ? "province"
          : area?.city?.length <= 0
          ? "city"
          : area?.district?.length <= 0
          ? "district"
          : "sub_district";
      setArea((old) => ({ ...old, [thisvalue]: data_area }));
    } catch (error) {
      console.log(error.messgae);
    }
  }, [
    area,
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan,
  ]);

  const filterTextArea = {
    province: forms?.alamat?.provinsi?.title,
    city: forms?.alamat?.kabupaten,
    district: forms?.alamat?.kecamatan,
    sub_district: forms?.alamat?.kelurahan?.title,
  };

  const isArea = (params) => {
    return area?.[params]
      ?.map((item, index) => ({
        id: item?.province_id
          ? item?.province_id
          : item?.area_id
          ? item?.area_id
          : index,
        title: item?.province_name
          ? item?.province_name
          : item?.city_name
          ? item?.city_name
          : item?.district_name
          ? item?.district_name
          : item?.subdistrict_name,
      }))
      .filter((item) =>
        !filterTextArea?.[params]
          ? item
          : item?.title
              .toLowerCase()
              ?.includes(filterTextArea?.[params]?.toLowerCase())
      );
  };

  const listFormDataCustomer = [
    {
      key: "recipets_name",
      fieldDB: "recipets_name",
      placeholder: "Masukkan nama penerima",
      label: "Nama Penerima",
      typeInput: "text",
    },
    {
      key: "telephone",
      fieldDB: "telephone",
      placeholder: "+62xxxxxxxxxxx",
      label: "No. Telp Penerima",
      typeInput: "text",
    },
  ];

  const listFormAlamatCustomer = [
    {
      key: "provinsi",
      keyArea: "province",
      placeholder: "Pilih Provinsi",
      label: "Provinsi",
      valueDropdown: forms?.alamat?.provinsi?.title,
      zIndex: 5,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {
        kabupaten: "",
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        city: [],
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kabupaten",
      keyArea: "city",
      disabled: !forms?.alamat?.provinsi,
      placeholder: "Pilih Kabupaten",
      label: "Kabupaten",
      valueDropdown: forms?.alamat?.kabupaten,
      zIndex: 4,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        district: [],
        sub_district: [],
      },
    },
    {
      key: "kecamatan",
      keyArea: "district",
      disabled: !forms?.alamat?.kabupaten,
      placeholder: "Pilih Kecamatan",
      label: "Kecamatan",
      valueDropdown: forms?.alamat?.kecamatan,
      zIndex: 3,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kelurahan: {
          id: 0,
          title: "",
        },
      },
      areaFieldKosong: {
        sub_district: [],
      },
    },
    {
      key: "kelurahan",
      keyArea: "sub_district",
      disabled: !forms?.alamat?.kecamatan,
      placeholder: "Pilih Kelurahan",
      label: "Kelurahan",
      valueDropdown: forms?.alamat?.kelurahan?.title,
      zIndex: 2,
      defaultState: {
        id: 0,
        title: "",
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
        };
      },
      alamatFieldKosong: {},
      areaFieldKosong: {},
    },
  ];

  return (
    <div className='flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8'>
      {/* Data Customer */}
      <div className='relative flex flex-col gap-4'>
        <div className='flex flex-col gap-4'>
          {listFormDataCustomer?.map((item, index) => (
            <Input
              key={index}
              onChange={handleChange(item?.key)}
              value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
              disabled={item?.disable}
              placeholder={item?.placeholder}
              label={item?.label}
              error={!errors?.[item?.key] ? false : true}
              caption={errors?.[item?.key]}
              type={item?.typeInput}
              variants={item?.variants}
              handleDropdown={item?.handleDropdown}
              icon={item?.handleIcon}
            />
          ))}
          {/* Detail Alamat */}
          <Input
            onChange={handleChange("address")}
            value={forms?.address}
            placeholder={"Masukkan detail alamat"}
            label={"Detail Alamat"}
            variants='textarea'
            error={!errors?.address ? false : true}
            caption={errors?.address}
          />
          {listFormAlamatCustomer?.map((item, index) => (
            <div
              key={index}
              className={twMerge(`z-[${item?.zIndex}]`)}>
              <Input
                value={item?.valueDropdown}
                placeholder={item?.placeholder}
                disabled={item?.disabled}
                label={item?.label}
                onChange={(value) => {
                  setForms((old) => ({
                    ...old,
                    alamat: {
                      ...old?.alamat,
                      [item?.key]: item?.changeState(value),
                    },
                  }));
                }}
                size='small'
                variants='dropdown'
                handleDropdown={{
                  show: showDropdown?.[`alamat_${item?.key}`],
                  showHIdden: () => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        [item?.key]: item?.defaultState,
                      },
                    }));
                    handleDropdown(`alamat_${item?.key}`);
                  },
                  datas: isArea(item?.keyArea),
                  onChange: (value) => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        ...item?.alamatFieldKosong,
                        [item?.key]: item?.changeState(value),
                      },
                    }));
                    setArea((old) => ({
                      ...old,
                      ...item?.areaFieldKosong,
                    }));
                  },
                  value: item?.valueDropdown,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className='flex flex-col xs:flex-row gap-4 xs:items-center justify-end'>
        <div className='items-start'>
          <Button
            label='Batal'
            variants='outline'
            onClick={() => {
              setForms({});
              router.back();
            }}
          />
        </div>
        <div className='items-start'>
          <Button
            label='Tambah'
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
}
